var React = require('react');

function Projects (props) {
    return React.createElement("svg",props,[React.createElement("polygon",{"className":"stroke-foreground fill-none","points":"19.9,10 15,10 12.5,14.3 15,18.5 19.9,18.5 22.4,14.3","key":0}),React.createElement("polygon",{"className":"stroke-foreground fill-none","points":"12.5,14.3 7.6,14.3 5.2,18.5 7.6,22.8 12.5,22.8 15,18.5","key":1}),React.createElement("polygon",{"className":"stroke-background fill-none","points":"12.5,1.1 4.9,1.1 1.1,7.7 4.9,14.3 12.5,14.3 16.4,7.7 ","key":2})]);
}

Projects.defaultProps = {"version":"1.1","width":"24px","height":"24px","viewBox":"0 0 24 24","xmlSpace":"preserve"};

module.exports = Projects;

Projects.default = Projects;
